import { UUID } from "../generic/uuid";
import { createVintageDtoFromOfferVintageModel, VintageModel } from "./vintage";
import { OfferModel } from "./offer";
import { VintageProductDto } from "@vini-wine/core-dtos";

export interface VintageProductModel extends UUID {
  // transform
  milliliters: number;

  // available includes
  vintage?: VintageModel;
  bestOffer?: OfferModel | null;
}

export const createVintageProductDtoFromOfferVintageProductModel = (
  vintageProduct: VintageProductModel,
): VintageProductDto => {
  return {
    uuid: vintageProduct.uuid,
    milliliters: vintageProduct.milliliters,
    vintage: vintageProduct.vintage
      ? createVintageDtoFromOfferVintageModel(vintageProduct.vintage)
      : undefined,
  };
};
